/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCallbackRequest
 */
export interface CreateCallbackRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCallbackRequest
     */
    originTimeZoneId: string;
}

/**
 * Check if a given object implements the CreateCallbackRequest interface.
 */
export function instanceOfCreateCallbackRequest(value: object): value is CreateCallbackRequest {
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    return true;
}

export function CreateCallbackRequestFromJSON(json: any): CreateCallbackRequest {
    return CreateCallbackRequestFromJSONTyped(json, false);
}

export function CreateCallbackRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallbackRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'originTimeZoneId': json['originTimeZoneId'],
    };
}

export function CreateCallbackRequestToJSON(json: any): CreateCallbackRequest {
    return CreateCallbackRequestToJSONTyped(json, false);
}

export function CreateCallbackRequestToJSONTyped(value?: CreateCallbackRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originTimeZoneId': value['originTimeZoneId'],
    };
}

